import React from 'react'
import { Box, CircularProgress, Typography, styled } from '@mui/material'

interface LoadingProps {
    message?: React.ReactNode
}

const Loading = ({ message }: LoadingProps) => {
    return (
        <RootStyled ownerState={{ variant: 'absolute' }}>
            <CircularProgress />
            { message && (
                <Typography variant="body2" align="center" sx={{ mt: 2 }}>
                    {message}
                </Typography>
            )}
        </RootStyled>
    )
}

const RootStyled = styled(Box)<{
    ownerState: { variant: string }
}>(({ ownerState }) => ({
    ...((ownerState.variant === 'absolute') && {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    })
}))

export default Loading
